import {
  AloftDate,
  AloftPrice,
  ConstellationOneListing,
  StandardStatus,
  expected,
  isDefined,
  isUndefined,
  listingStatusToUADStatus,
} from '@aloft/toolkit-shared';

import { PropertyTooltip, PropertyTooltipProps } from '../../../components/PropertyTooltip.tsx';
import MapBox from '../../../components/map/MapBox.ts';
import { MapPopup } from '../../adjustPairedSalesStandalone/components/PairedSalesMap/MapPopup.tsx';
import { getBathsTotalInteger } from '../MLSDataSheet/utils/getBathsTotalInteger.ts';
import { getStringValue } from '../MLSDataSheet/utils/getStringValue.ts';
import { MapData } from '../hooks/useMapCoords.ts';
import { NoMlsDataTooltip } from './NoMlsDataTooltip.tsx';

const PLACEHOLDER = '-';

function propertyTooltipPropsFromListing(listing: ConstellationOneListing): PropertyTooltipProps {
  const listingStatus = listingStatusToUADStatus(listing.StandardStatus as StandardStatus);
  const isSold = listingStatus === 'SettledSale';
  const beds = getStringValue(listing.BedroomsTotal ?? PLACEHOLDER);
  const baths = getBathsTotalInteger(listing);
  const gla = listing.LivingArea?.toLocaleString('en-US') ?? PLACEHOLDER;
  const address1 = listing.UnparsedAddress ?? '';
  const address2 = `${listing.City ?? ''}${listing.City && listing.StateOrProvince ? ', ' : ''}${
    listing.StateOrProvince ?? ''
  }${listing.City || listing.StateOrProvince ? ' ' : ''}${listing.PostalCode ?? ''}`;
  const addressParts: readonly [string, string] = [address1, address2];
  const closeDate = AloftDate.fromIsoString(listing.CloseDate);
  const salePrice = listing.ClosePrice
    ? AloftPrice.fromNumericPrice(listing.ClosePrice)
    : undefined;
  const listPrice = listing.ListPrice ? AloftPrice.fromNumericPrice(listing.ListPrice) : undefined;
  const photoUrl = listing.Media?.[0]?.MediaURL;

  return { isSold, beds, baths, gla, addressParts, closeDate, salePrice, listPrice, photoUrl };
}

type MlsMapPropertyTooltipProps = {
  property?: MapData;
  mapRef: React.MutableRefObject<MapBox | null>;
};

export const MlsMapPropertyTooltip = ({ property, mapRef }: MlsMapPropertyTooltipProps) => {
  if (isUndefined(property)) {
    return null;
  }
  return (
    <MapPopup
      map={mapRef.current?.getMap()}
      lat={expected(property.lat)}
      lng={expected(property.lng)}
    >
      {isDefined(property.listing) ? (
        <PropertyTooltip {...propertyTooltipPropsFromListing(property.listing)} />
      ) : (
        <NoMlsDataTooltip />
      )}
    </MapPopup>
  );
};
